import { useState,useEffect } from "react"
import { Box,useToast,SkeletonCircle,SkeletonText,Text,Select, Button, Center } from "@chakra-ui/react"
import { CheckIcon } from "@chakra-ui/icons"
import { MdCancel } from "react-icons/md"
import { getLokacije_V3 } from "../../util/apiLokacija"
export default function LokacijaSelect2({size='xs',defaultOdjeljakId=0,onOdjeljakSelect,onCancel, direction='column',odustaniButton=true}) {

const [lok,setLok]=useState([])
const [tov,setTov]=useState([])
const [odj,setOdj]=useState([])
const [selectedlok,setSelectedLok]=useState(0)
const [selectedtov,setSelectedTov]=useState(0)
const [selectedodj,setSelectedOdj]=useState(0)
const [isfetching,setIsFetching]=useState(true);
const toast=useToast()
useEffect(() => {
  const fetchData=async()=>{
    let _errmsg="";
    try {
        const res=await getLokacije_V3();
        if (res.status===200) {
            const _lok=res.res.filter((item)=>item.lokacija_tip_id===1);    
            const _tov=res.res.filter((item)=>item.lokacija_tip_id===2);
            const _odj=res.res.filter((item)=>item.lokacija_tip_id===3);
            setLok(_lok);
            setTov(_tov);
            setOdj(_odj);
            let _selectedTovId=0;
            let _selectedOdjId=Number(defaultOdjeljakId);
            let _selectedLokId=0;
            if (defaultOdjeljakId===0) {
                _selectedLokId=_lok[0].id;
                //setSelectedLok(_lok[0].id)
                _selectedTovId=_tov.filter((item)=>item.parent_id===_lok[0].id)[0].id
                _selectedOdjId=_odj.filter((item)=>item.parent_id===_selectedTovId)[0].id
                    
            } else {
                _selectedTovId=Number(_odj.filter((item)=>item.id===defaultOdjeljakId)[0].parent_id);
                _selectedLokId=Number(_tov.filter((item)=>item.id===_selectedTovId)[0].parent_id);
            }
            setSelectedLok(_selectedLokId);
            setSelectedTov(_selectedTovId);
                setSelectedOdj(_selectedOdjId);
        } else {
            _errmsg=res.message;
        }
        
    } catch (error) {
        _errmsg=error.message;
    } finally {
        if (_errmsg==="") {
            setIsFetching(false);    
        } else {
            toast({
                title:"RGG",
                status:"error",
                description:_errmsg,
                isClosable:true,
                duration:2500,
                position:"top-right",
            });
        }
        
    }
  }
  fetchData();
}, [])

const showIsFetching=()=>{
    if (isfetching) {
        return (
            <Box>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={15} spacing='3' skeletonHeight='2' />
            </Box>
        )
    }
}

const selectLokacija=(e)=>{
    const lokid=Number(e.target.value);
    let tovid=0;
    let odjid=0;
    setSelectedLok(lokid);
    tovid=Number(tov.filter((item)=>item.parent_id===lokid)[0].id);
    setSelectedTov(tovid);
    odjid=Number(odj.filter((item)=>item.parent_id===tovid)[0].id);
    setSelectedOdj(odjid);
    
    
    
    
}

const selectToviliste=(e)=>{
   
    
    const tovid=Number(e.target.value);
    let odjid=0;
    
    setSelectedTov(tovid);
    odjid=Number(odj.filter((item)=>item.parent_id===tovid)[0].id);
    setSelectedOdj(odjid);
    
}

const selectOdjeljak=(e)=>{
   
    setSelectedOdj(e.target.value);
    OdjeljakIsSelected(e.target.value);
    /*if (onOdjeljakSelect!==undefined) {
        onOdjeljakSelect(e.target.value,_nazivodj)    
    }
    if (onCancel!==undefined) {
        onCancel();
    }*/
    
}

const OdjeljakIsSelected=(_idodj)=>{
    let _nazivodj="";
    let _nazivtov="";
    let _nazivlok="";
    //let _i=odj.findIndex((item)=>item.id.toString()===selectedodj.toString());
    let _i=odj.findIndex((item)=>item.id.toString()===_idodj);
    if (_i>=0) {
        _nazivodj=odj[_i].naziv;
    }
    _i=tov.findIndex((item)=>item.id.toString()===selectedtov.toString());
    if (_i>=0) {
        _nazivtov=tov[_i].naziv;
    }
    _i=lok.findIndex((item)=>item.id.toString()===selectedlok.toString());
    if (_i>=0) {
        _nazivlok=lok[_i].naziv;
    }
    onOdjeljakSelect(_idodj,_nazivodj,_nazivtov,_nazivlok);
}

const getLokacije=()=>{
    return (
        <Select focusBorderColor='grunt2.400' size={size} variant={'outline'} defaultValue={selectedlok} onChange={selectLokacija}>
            {
                lok.map((item,index)=>{
                    return (
                        <option value={item.id}>{item.naziv}</option>
                    )
                })
            
            }
        </Select>
    )
}

const getTovilista=()=>{
    return (
        <Select focusBorderColor='grunt2.400' size={size} variant={'outline'} defaultValue={selectedtov} onChange={selectToviliste}>
            {
                tov.map((item,index)=>{
                    if (item.parent_id.toString()===selectedlok.toString()) {
                        return (
                            <option value={item.id}>{item.naziv}</option>
                        )    
                    }
                    
                })
            
            }
        </Select>
    )
}

const getOdjeljke=()=>{
    return (
        <Select focusBorderColor='grunt2.400' size={size} variant={'outline'} defaultValue={selectedodj} onChange={selectOdjeljak}>
            {
                odj.map((item,index)=>{
                    if (item.parent_id.toString()===selectedtov.toString()) {
                        return (
                            <option value={item.id}>{item.naziv}</option>
                        )    
                    }
                    
                })
            
            }
        </Select>
    )
}
const buildScreen=()=>{
    const _dirt=direction==='column'?'column':'row';
    if (!isfetching) {
        return (
        <Box display={'flex'} flexDirection={_dirt} flex={1} gap={'0.5rem'} w={'100%'}  alignItems={_dirt==='column'?'normal':'end'} >
            
            <Box display={'flex'} flexDir={'column'} flex={10}>
                <Text fontWeight={'semibold'}>Lokacija</Text>
                {getLokacije()}
            </Box>
            <Box display={'flex'} flexDir={'column'} flex={10}>
                <Text fontWeight={'semibold'}>Tovilište</Text>
                {getTovilista()}
            </Box>
            <Box display={'flex'} flexDir={'column'} flex={10}>
                <Text fontWeight={'semibold'}>Boks</Text>
                {getOdjeljke()}
            </Box>
            {odustaniButton?
            _dirt==="row"?
            <Box display={'flex'} flexDir={'column'} flex={1}>
                <Button leftIcon={<MdCancel/>} variant={'outline'} colorScheme={'grunt2'} size={size} onClick={onCancel}>Odustani</Button>
            </Box>:
            <Box>
                <Button leftIcon={<MdCancel/>} variant={'outline'} colorScheme={'grunt2'} size={size} onClick={onCancel}>Odustani</Button>
            </Box>
            :null}
            
        </Box>
        )
    }
}

return (
    <Box display={'flex'} flexDir={'column'}fontSize={'xs'}>
        {showIsFetching()}
        {buildScreen()}
    </Box>
)

}